import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, FormField, Input } from '../../components/ui/index.js';
import { api } from '../../lib/api.js';
import { useAuthStore } from '../../lib/authStore.js';

import { ChangePasswordCard } from './ChangePasswordCard.js';

export function ProfilePage(): JSX.Element {
  const { t } = useTranslation('settings');
  const { t: tc } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const [fullName, setFullName] = useState(user?.fullName ?? '');
  const [saving, setSaving] = useState(false);

  if (!user) return <p>{t('profile.title')}</p>;

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api().patch('/me', { fullName });
      useAuthStore.setState((s) => ({ ...s, user: { ...user, fullName: r.data.fullName } }));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <Card>
        <h2 className="mb-4 text-lg font-semibold">{t('profile.title')}</h2>
        <form className="flex flex-col gap-4" onSubmit={onSubmit}>
          <FormField id="fullName" label={t('profile.fullName')}>
            <Input id="fullName" value={fullName} onChange={(e) => setFullName(e.target.value)} />
          </FormField>
          <FormField id="email" label={t('profile.email')}>
            <Input id="email" value={user.email} disabled />
          </FormField>
          <Button type="submit" loading={saving} className="self-start">
            {tc('actions.save')}
          </Button>
        </form>
      </Card>

      <ChangePasswordCard
        submit={async (currentPassword, newPassword) => {
          await api().post('/auth/change-password', { currentPassword, newPassword });
        }}
      />
    </div>
  );
}
